module.exports = "https://99designs-start-assets.imgix.net/js/79fd165979d6eebc371e4c2eff3323d9.png";